import classes from './ReadMore.module.css';
import { LanguageContext } from '../../../../context/LanguageContext';
import { useCallback, useEffect, useRef, useState } from 'react';

const ReadMore = (props) => {
  const descriptionRef = useRef(null)
  const [isMore, setIsMore] = useState();
  const [isDescription, setIsDescription] = useState(false);
  const { data, className, description, read_more_container, buttonStyle, isLocked = false } = props;

  const readMoreHandler = () => {
    if (
      descriptionRef.current?.scrollHeight >= descriptionRef.current?.clientHeight &&
      !isDescription && (isMore || isMore === undefined)
    ) {
      setIsDescription(true);
      setIsMore(false);
    } else if (
      descriptionRef.current?.scrollHeight >= descriptionRef.current?.clientHeight &&
      isDescription && !isMore
    ) {
      setIsDescription(false);
      setIsMore(true);
    }
  };

  useEffect(() => {
    if (descriptionRef.current?.scrollHeight > descriptionRef.current?.clientHeight) {
      setIsMore(true);
    } else {
      setIsMore(false);
    }
  }, [data]);

  const updateDimensions = useCallback(() => {
    if (descriptionRef.current?.scrollHeight > descriptionRef.current?.clientHeight) {
      setIsMore(true);
    } else {
      setIsMore(false);
    }
    setIsDescription(false);
  }, []);

  useEffect(() => {
    window.addEventListener('resize', updateDimensions);
    return () => window.removeEventListener('resize', updateDimensions);
  }, [updateDimensions]);

  useEffect(() => {
    if (descriptionRef.current?.clientHeight) {
    if (descriptionRef.current?.scrollHeight && descriptionRef.current?.scrollHeight > descriptionRef.current?.clientHeight) {
      setIsMore(true);
    } else if (descriptionRef.current?.clientHeight) {
      setIsMore(false);
    }
  }
  }, [descriptionRef.current?.clientHeight])

  return (
    <LanguageContext.Consumer>
      {(ctx) => {
        return (
          <div>
            <span
              ref={descriptionRef}
              className={`${!isDescription ? `${description} w-100 overflow-hidden` : `${read_more_container} w-100 overflow-hidden`}`}
              onClick={isLocked ? undefined : readMoreHandler}
              id='description'
            >
              {data[ctx.language]}
            </span>
            <div className={buttonStyle}>
            {!isLocked && (
              (isMore !== undefined ? isMore : descriptionRef.current?.scrollHeight > descriptionRef.current?.clientHeight) ? (
                <button className={`${classes.read_more} ${className} border-0 bg-transparent`} onClick={readMoreHandler}>
                  {ctx.data?.more[ctx.language]}
                </button>
              ) : null
            )}
            </div>
          </div>
        );
      }}
    </LanguageContext.Consumer>
  );
};

export default ReadMore;
